import { render, staticRenderFns } from "./GridCulturalOrganizations.vue?vue&type=template&id=98e00538&"
import script from "./GridCulturalOrganizations.vue?vue&type=script&lang=js&"
export * from "./GridCulturalOrganizations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('98e00538')) {
      api.createRecord('98e00538', component.options)
    } else {
      api.reload('98e00538', component.options)
    }
    module.hot.accept("./GridCulturalOrganizations.vue?vue&type=template&id=98e00538&", function () {
      api.rerender('98e00538', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/culturalOrganizations/grid/GridCulturalOrganizations.vue"
export default component.exports